import {FormView} from '@src/components/_views/configurable/FormView';
import {withRouterApi} from '@src/HOCs/withRouterApi';
import {FormViewProps} from '@src/@types/components/FormViewProps';
import TechOperationsForm from './TechOperationsForm';

export class TechOperationsUpdateForm extends FormView {
    protected getFormComponent() {
        return TechOperationsForm;
    }
}

export default TechOperationsUpdateForm.getStoreConnector()(withRouterApi<FormViewProps>(TechOperationsUpdateForm));
